import { render, staticRenderFns } from "./release-video.vue?vue&type=template&id=3e064854&scoped=true"
import script from "./release-video.vue?vue&type=script&lang=js"
export * from "./release-video.vue?vue&type=script&lang=js"
import style0 from "./release-video.vue?vue&type=style&index=0&id=3e064854&prod&lang=less&scoped=true"
import style1 from "./release-video.vue?vue&type=style&index=1&id=3e064854&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e064854",
  null
  
)

export default component.exports